import CustomerHome from "customer/customer-home/customer-home";
import Completed from "customer/orders/completed/completed";
import CreateOrder from "customer/orders/create-order/create-order";
import Pending from "customer/orders/myBooking/myBooking";
import Shipping from "customer/orders/myBalance/my-balance";
import Reports from "customer/reports/reports";
import CompanyAddress from "customer/settings/address/company-address/company-address";
import CustomerAddress from "customer/settings/address/customer-address/customer-address";
import ChangePassword from "customer/settings/changePassword/changePassword";
import CompanyInfo from "customer/settings/companyInfo/companyInfo";
import GrantedUsers from "customer/settings/grantedUsers/grantedUsers";
import AssignedRep from "customer/settings/myContract/assignedRep/assignedRep";
import ContractFile from "customer/settings/myContract/contractFile/contractFile";
import ContractInfo from "customer/settings/myContract/ContractInfo/ContractInfo";
import MyContract from "customer/settings/myContract/myContract";
import MyProfile from "customer/settings/myProfile/myProfile";
import Preferences from "customer/settings/preferences/preferences";
import SettingHome from "customer/settings/settingHome";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { CustomerNavbar } from "shared/component/navbar/navbar";
import BankAccount from "./bankAccount/bankAccount";
import ControlledOffices from "./ControlledOffices/ControlledOffices";
import Summary from "./orders/create-order/summary";
import ViewOrder from "./orders/viewOrder/viewOrder";
import MyBalance from "customer/orders/myBalance/my-balance";
import MyBooking from "customer/orders/myBooking/myBooking";
import BookingUsers from "./settings/bookingUsers/bookingUsers";

function CustomerRoutes(props) {
  return (
    <div className="customerApp">
      <CustomerNavbar />
      <Routes>
        <Route path='/' element={<CustomerHome />} />
        <Route path="/new-order" element={<CreateOrder />} />
        {/*<Route path="/shipping-details" element={<ShippingDetails />} />*/}
        {/*<Route path="/from-details" element={<FromDetails />} />*/}
        {/*<Route path="/to-details" element={<ToDetails />} />*/}
        {/*<Route path="/destinations" element={<Destinations />} />*/}
        <Route path="/summary" element={<Summary />} />
        <Route path="/bank-account" element={<BankAccount />} />
        <Route path="/controlled-offices" element={<ControlledOffices />}/>
        <Route path="/my-booking" element={<MyBooking />} />
        <Route path="/my-balance" element={<MyBalance />} />
        <Route path="/view-order" element={<ViewOrder />} />
        <Route path="/completed" element={<Completed />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<SettingHome />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/company-info" element={<CompanyInfo />} />
        <Route path="/preferences" element={<Preferences />} />
        <Route path="/booking-users" element={<BookingUsers />} />
        <Route path="myContract/*" element={<MyContract />}>
          <Route index element={<AssignedRep />} />
          <Route path="contractInfo" element={<ContractInfo />} />
          <Route path="contractFile" element={<ContractFile />} />
        </Route>
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="addresses/*" element={<Outlet />}>
          <Route index element={<Navigate to='company' />} />
          <Route path="company" element={<CompanyAddress />} />
          <Route path="customer" element={<CustomerAddress />} />
        </Route>
        <Route path="granted-users" element={<GrantedUsers />} />
      </Routes>
    </div>
  );
}

export default CustomerRoutes;